import { render, staticRenderFns } from "./PersistenceTemplate.vue?vue&type=template&id=51fbc0ae"
import script from "./PersistenceTemplate.vue?vue&type=script&lang=js"
export * from "./PersistenceTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports